import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getCompanyFormList = () => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getCompanyFormList`);
    dispatch({
      type: action_types.COMPANY_FORM_LIST,
      data,
    });
  };
};

export const getCompanyFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getCompanyFormData/${id}`);
    dispatch({
      type: action_types.COMPANY_FORM_DATA,
      data,
    });
  };
};

export const getUserDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getUserDetailById/${id}`);
      dispatch({
        type: action_types.USER_DETAIL_BY_ID,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.USER_DETAIL_BY_ID,
        data: { loading: false },
      });
    }
  };
};

export const removeUserDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.USER_DETAIL_BY_ID,
      data: { payload: {}, loading: true },
    });
  };
};
